




















import { POSPaymentMethod, POSTicket } from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-pos-payment-methods',
  components: {},
})
export default class PosPaymentMethods extends Vue {
  @Prop({ type: Array, required: true }) readonly paymentMethodOptions: POSPaymentMethod[];
  @Prop({ type: [Object, null] }) readonly currentTicket: POSTicket | null;
  @Prop({ type: Boolean }) readonly disabled: boolean;
  @Prop({ type: Number }) readonly amountToPay: number;

  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
  public canBeUsed(method: POSPaymentMethod = null): boolean {
    const terminals = ['wipay_terminal', 'nepting'];
    if (terminals.includes(method.value)) {
      return this.amountToPay >= 0;
    }
    return true;
  }

  public onPaymentMethodClicked(method = null) {
    this.$emit('payment-method-clicked', method);
  }
}
